export default {"src":"/_next/static/media/logo-twitter-white.d91648df.svg","height":100,"width":100};